import { css } from '@emotion/react';

// Shared styles for signup drawer step components

// CodeStep styles
export const helperTextStyles = css`
  font-size: 12px;
`;

export const resendLinkStyles = css`
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
`;

// MethodStep styles
export const facebookButtonStyles = css`
  background-color: #1877f2;
  border-color: #1877f2;

  &:hover {
    background-color: #166fe5;
    border-color: #166fe5;
  }
`;

// ProfileStep styles
export const warningBoxStyles = css`
  background-color: var(--color-warning-100);
  border-radius: var(--radius-sm);
`;

export const warningTextStyles = css`
  color: var(--color-warning-700);
`;
